import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import DemoTour from "./DemoTour";
import {
  LogOut, Users, BarChart3, Bell, ShieldAlert, ListChecks,
  ClipboardCheck, TrendingUp, ShieldCheck, Activity, Sparkles
} from "lucide-react";

export const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const NavItem = ({ to, icon: Icon, label, testId }) => {
    const active = loc.pathname === to;
    return (
      <Link
        to={to}
        data-testid={testId}
        className={`flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-opacity ${
          active ? "bg-primary text-primary-foreground" : "text-foreground/70 hover:bg-secondary"
        }`}
      >
        <Icon className="h-4 w-4" />
        <span>{label}</span>
      </Link>
    );
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="flex">
        <aside className="sticky top-0 hidden h-screen w-64 shrink-0 border-r border-border bg-card lg:block">
          <div className="flex items-center gap-2 border-b border-border px-5 py-5">
            <div className="rounded-md p-1.5" style={{ background: "hsl(var(--haruki-leaf))" }}>
              <ShieldCheck className="h-4 w-4 text-white" />
            </div>
            <div>
              <div className="font-heading text-base font-semibold leading-none">Haruki Health</div>
              <div className="mt-1 text-[10px] uppercase tracking-widest text-muted-foreground">
                Agency Console
              </div>
            </div>
          </div>
          <nav className="space-y-1 px-3 py-4">
            <NavItem to="/agency" icon={BarChart3} label="Overview" testId="admin-nav-overview" />
            <NavItem to="/agency/roster" icon={Users} label="Roster" testId="admin-nav-roster" />
            <NavItem to="/agency/completion" icon={ListChecks} label="Completion" testId="admin-nav-completion" />
            <NavItem to="/agency/engagement" icon={Activity} label="Engagement" testId="admin-nav-engagement" />
            <NavItem to="/agency/sos" icon={Bell} label="SOS Signals" testId="admin-nav-sos" />
            <NavItem to="/agency/critical-incident" icon={ShieldAlert} label="Critical Incident" testId="admin-nav-critical" />
            <NavItem to="/agency/clinical-review" icon={ClipboardCheck} label="Clinical Review" testId="admin-nav-clinical" />
            <NavItem to="/agency/production-queue" icon={ListChecks} label="Production Queue" testId="admin-nav-production" />
            <NavItem to="/agency/demand-signals" icon={TrendingUp} label="Demand Signals" testId="admin-nav-demand" />
            <NavItem to="/agency/leads" icon={Sparkles} label="Lead Analytics" testId="admin-nav-leads" />
          </nav>
          <div className="absolute bottom-0 left-0 right-0 border-t border-border px-5 py-4">
            <div className="mb-2 truncate text-xs text-muted-foreground">{user?.email}</div>
            <button
              data-testid="admin-logout-button"
              onClick={async () => { await logout(); nav("/"); }}
              className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
            >
              <LogOut className="h-4 w-4" /> Log out
            </button>
          </div>
        </aside>

        <main className="min-h-screen flex-1">
          <div className="mx-auto max-w-7xl px-6 py-8 lg:px-10 lg:py-10">
            {children}
          </div>
        </main>
      </div>
      <DemoTour />
    </div>
  );
};

export default AdminLayout;
